// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/splide.min","css/global"], () => (__webpack_require__("./src/js/cda.js")))
__webpack_require__.O(undefined, ["css/splide.min","css/global"], () => (__webpack_require__("./src/css/global.css")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/splide.min","css/global"], () => (__webpack_require__("./node_modules/@splidejs/splide/dist/css/splide.min.css")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
